import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Users, Globe, Star, Award, ArrowRight, ShieldCheck } from 'lucide-react';
import PageLayout from '../../components/Layout/PageLayout';
import PageHeader from '../../components/PageHeader/PageHeader';
import ModernCTA from '../../components/CTA/ModernCTA';
import './ModernViewPartners.scss';

// NASA SEWP VI OEM Partner logos
import ciscoLogo from '../../images/brands/cisco-logo.svg';
import dellLogo from '../../images/brands/Dell_Logo.svg.png';
import hpLogo from '../../images/brands/Hewlett-Packard-Logo.wine.png';
import samsungLogo from '../../images/brands/samsung-logo.svg';

// Partner Images
import img1 from '../../images/partnes/WIth Removed Background/1-2-removebg-preview.png'
import img2 from '../../images/partnes/WIth Removed Background/11837-ambir_logo-removebg-preview.png'
import img3 from '../../images/partnes/WIth Removed Background/1631349424253-removebg-preview (1).png'
import img4 from '../../images/partnes/WIth Removed Background/20090518-duplim-logo-gold-2915x989-removebg-preview.png'
import img5 from '../../images/partnes/WIth Removed Background/5245225c-7576-4067-9b69-c765f919c8ea.5fb58ccd85b1b3f7cc48351ee40f2894-removebg-preview.png'
import img6 from '../../images/partnes/WIth Removed Background/60-removebg-preview.png'
import img7 from '../../images/partnes/WIth Removed Background/63779_2560pxadvantech_logo_654374-removebg-preview.png'
import img8 from '../../images/partnes/WIth Removed Background/9785de11317909.560f5ae9d03dd-removebg-preview.png'
import img9 from '../../images/partnes/WIth Removed Background/ACTI_LOGO-500x515-removebg-preview.png'
import img10 from '../../images/partnes/WIth Removed Background/EZD_LOGO_high_res_original-removebg-preview.png'
import img11 from '../../images/partnes/WIth Removed Background/Energizer_Logo.svg-removebg-preview.png'
import img12 from '../../images/partnes/WIth Removed Background/HAVIS_Logo-removebg-preview.png'
import img13 from '../../images/partnes/WIth Removed Background/Legrand__company_-Logo.wine-removebg-preview.png'
import img14 from '../../images/partnes/WIth Removed Background/Lexmark-Logo-removebg-preview.png'
import img15 from '../../images/partnes/WIth Removed Background/Planar_Systems-Logo.wine-removebg-preview.png'
import img16 from '../../images/partnes/WIth Removed Background/R-001-J-sm-removebg-preview.png'
import img17 from '../../images/partnes/WIth Removed Background/Super_Micro_Computer_Logo.svg-removebg-preview.png'
import img18 from '../../images/partnes/WIth Removed Background/Targus-Logo-Med-Purple-removebg-preview.png'
import img19 from '../../images/partnes/WIth Removed Background/TouchDynamic-Logo-removebg-preview.png'
import img20 from '../../images/partnes/WIth Removed Background/UAGLogo-removebg-preview.png'
import img21 from '../../images/brands/logo.webp'
import img22 from '../../images/partnes/WIth Removed Background/Wilson-electronics-logo-removebg-preview.png'
import img23 from '../../images/partnes/WIth Removed Background/accortec_inc_logo-removebg-preview.png'
import img24 from '../../images/partnes/WIth Removed Background/add-on-removebg-preview.png'
import img25 from '../../images/partnes/WIth Removed Background/altronix_logo-removebg-preview.png'
import img26 from '../../images/partnes/WIth Removed Background/apc3559.logowik.com-removebg-preview.png'
import img27 from '../../images/partnes/WIth Removed Background/apricorn-cybersecurity-removebg-preview.png'
import img28 from '../../images/partnes/WIth Removed Background/c6cd95fb-3fbb-4db4-8d99-8def7dbc831d.avif'
import img29 from '../../images/partnes/WIth Removed Background/cherry-logo-removebg-preview.png'
import img30 from '../../images/partnes/WIth Removed Background/digi_international_logo-removebg-preview.png'
import img31 from '../../images/partnes/WIth Removed Background/fellows_logo-thumb-1-removebg-preview.png'
import img32 from '../../images/partnes/WIth Removed Background/images (2).png'
import img33 from '../../images/partnes/WIth Removed Background/images-removebg-preview (1).png'
import img34 from '../../images/partnes/WIth Removed Background/images-removebg-preview.png'
import img35 from '../../images/partnes/WIth Removed Background/images__3_-removebg-preview.png'
import img36 from '../../images/partnes/WIth Removed Background/images__4_-removebg-preview.png'
import img37 from '../../images/partnes/WIth Removed Background/images__5_-removebg-preview.png'
import img38 from '../../images/partnes/WIth Removed Background/images__6_-removebg-preview.png'
import img39 from '../../images/partnes/WIth Removed Background/images__7_-removebg-preview.png'
import img40 from '../../images/partnes/WIth Removed Background/investment-SPRichards-removebg-preview.png'
import img41 from '../../images/partnes/WIth Removed Background/lenovo-logo-brand-phone-symbol-name-red-design-china-mobile-illustration-free-vector-removebg-preview.png'
import img42 from '../../images/partnes/WIth Removed Background/logo-removebg-preview (1).png'
import img43 from '../../images/partnes/WIth Removed Background/logo-removebg-preview.png'
import img44 from '../../images/partnes/WIth Removed Background/omnitron-logo-new2-removebg-preview.png'
import img45 from '../../images/partnes/WIth Removed Background/peerless_av.960_0_1__1_-removebg-preview.png'
import img46 from '../../images/partnes/WIth Removed Background/pny-technologies4162.logowik.com-removebg-preview.png'
import img47 from '../../images/partnes/WIth Removed Background/seh-letter-logo-design-in-illustration-logo-calligraphy-designs-for-logo-poster-invitation-etc-vector-removebg-preview.png'
import img48 from '../../images/partnes/WIth Removed Background/seiko-logo-png_seeklogo-124537-removebg-preview.png'
import img49 from '../../images/partnes/WIth Removed Background/silicon-power-logo-png_seeklogo-485492-removebg-preview.png'
import img50 from '../../images/partnes/WIth Removed Background/starkey-removebg-preview.png'
import img51 from '../../images/partnes/WIth Removed Background/transition-networks-vector-logo-removebg-preview.png'
import img52 from '../../images/partnes/WIth Removed Background/untitled-1_107-removebg-preview.png'
import img53 from '../../images/partnes/WIth Removed Background/v7_logo_footer-removebg-preview.png'
import img54 from '../../images/partnes/WIth Removed Background/w_200221_00527-removebg-preview.png'
import img55 from '../../images/partnes/WIth Removed Background/ybh81la9tepyt1irvtbm-removebg-preview.png'

// Federal Images
import fd1 from '../../images/partnes/Federal Clients/Federal Clients Logos/Department_Of_The_Treasury-removebg-preview.png'
import fd2 from '../../images/partnes/Federal Clients/Federal Clients Logos/Department_of_Defence-removebg-preview.png'
import fd4 from '../../images/partnes/Federal Clients/Federal Clients Logos/Department_of_Labour_-removebg-preview.png'
import fd5 from '../../images/partnes/Federal Clients/Federal Clients Logos/Department_of_States-removebg-preview.png'
import fd6 from '../../images/partnes/Federal Clients/Federal Clients Logos/Department_of_Transportation-removebg-preview.png'
import fd9 from '../../images/partnes/Federal Clients/Federal Clients Logos/Department_of_the_Interior_s-removebg-preview.png'
import fd10 from '../../images/partnes/Federal Clients/Federal Clients Logos/Trasnsportation_Command-removebg-preview.png'
import fd11 from '../../images/partnes/Federal Clients/Federal Clients Logos/U.S._Department_of_Agriculture-removebg-preview.png'
import fd12 from '../../images/partnes/Federal Clients/Federal Clients Logos/U.S._Department_of_Commerce-removebg-preview.png'
import fd13 from '../../images/partnes/Federal Clients/Federal Clients Logos/U.S._Department_of_Energy-removebg-preview.png'
import fd14 from '../../images/partnes/Federal Clients/Federal Clients Logos/U.S._Department_of_Housing-removebg-preview.png'
import fd15 from '../../images/partnes/Federal Clients/Federal Clients Logos/US_Department_of_Heath_and_Human_Services_-removebg-preview.png'

// Federal agency seals (requested priority set)
import sealHomeland from '../../images/certifications/Seal_of_the_United_States_Department_of_Homeland_Security.svg.webp'
import sealDLA from '../../images/certifications/Seal_of_the_Defense_Logistics_Agency.svg.webp'
import sealArmy from '../../images/certifications/Emblem_of_the_U.S._Department_of_the_Army.svg'
import sealAirForce from '../../images/certifications/Seal_of_the_United_States_Department_of_the_Air_Force.svg.webp'
import sealNavy from '../../images/certifications/Seal_of_the_United_States_Department_of_the_Navy.svg.webp'
import sealCoastGuard from '../../images/certifications/Seal_of_the_United_States_Coast_Guard.svg.webp'
import sealVA from '../../images/certifications/Seal_of_the_U.S._Department_of_Veterans_Affairs.svg.webp'
import sealJustice from '../../images/certifications/Seal_of_the_United_States_Department_of_Justice.svg.webp'
import sealGSA from '../../images/certifications/Seal_of_the_General_Services_Administration.svg.webp'

// Local Images
import local1 from '../../images/partnes/Local State and Educational/Local State and Education/Local/City of Anaheim.png'
import local2 from '../../images/partnes/Local State and Educational/Local State and Education/Local/City of Bakersfield.png'
import local3 from '../../images/partnes/Local State and Educational/Local State and Education/Local/City of Burbank.png'
import local4 from '../../images/partnes/Local State and Educational/Local State and Education/Local/City of Clovis.png'
import local5 from '../../images/partnes/Local State and Educational/Local State and Education/Local/City of Glendale.png'
import local6 from '../../images/partnes/Local State and Educational/Local State and Education/Local/City of Norco.jpg'
import local7 from '../../images/partnes/Local State and Educational/Local State and Education/Local/City of San Bernardino.jpg'
import local8 from '../../images/partnes/Local State and Educational/Local State and Education/Local/County of El Dorado.png'
import local9 from '../../images/partnes/Local State and Educational/Local State and Education/Local/Foothill Transit.jpg'
import local11 from '../../images/partnes/Local State and Educational/Local State and Education/Local/Kenton County Airport Board.png'
import local12 from '../../images/partnes/Local State and Educational/Local State and Education/Local/SAWS.png'
import local13 from '../../images/partnes/Local State and Educational/Local State and Education/Local/SPETA.png'
import local14 from '../../images/partnes/Local State and Educational/Local State and Education/Local/The Metropolitan Water District of Southern California.jpg'
import local15 from '../../images/partnes/Local State and Educational/Local State and Education/Local/cityofirving.png'
import local16 from '../../images/partnes/Local State and Educational/Local State and Education/Local/clarkcountynv.jpg'
import local17 from '../../images/partnes/Local State and Educational/Local State and Education/Local/davenport.jpg'
import local18 from '../../images/partnes/Local State and Educational/Local State and Education/Local/elpasotexas.png'
import local19 from '../../images/partnes/Local State and Educational/Local State and Education/Local/fayetteville.png'
import local20 from '../../images/partnes/Local State and Educational/Local State and Education/Local/granbury.png'
import local21 from '../../images/partnes/Local State and Educational/Local State and Education/Local/lexingtonky.png'
import local22 from '../../images/partnes/Local State and Educational/Local State and Education/Local/omnitrans.png'
import local23 from '../../images/partnes/Local State and Educational/Local State and Education/Local/orange county fire.jpg'
import local24 from '../../images/partnes/Local State and Educational/Local State and Education/Local/psta.jpg'
import local25 from '../../images/partnes/Local State and Educational/Local State and Education/Local/riverbay.jpg'
import local26 from '../../images/partnes/Local State and Educational/Local State and Education/Local/tarrantcountytx.png'

// State Images
import s1 from '../../images/partnes/Local State and Educational/Local State and Education/State/NGEM.png'
import s2 from '../../images/partnes/Local State and Educational/Local State and Education/State/cammnet.png'
import s3 from '../../images/partnes/Local State and Educational/Local State and Education/State/commbuys.gif'
import s4 from '../../images/partnes/Local State and Educational/Local State and Education/State/emma.png'
import s5 from '../../images/partnes/Local State and Educational/Local State and Education/State/lcpscm.png'
import s6 from '../../images/partnes/Local State and Educational/Local State and Education/State/mdcourts.jpg'
import s7 from '../../images/partnes/Local State and Educational/Local State and Education/State/neco.gif'
import s8 from '../../images/partnes/Local State and Educational/Local State and Education/State/ohio buys.png'

// Education Images
import eduDeptEducation from '../../images/partnes/Local State and Educational/Local State and Education/Local/Seal_of_the_United_States_Department_of_Education.svg'
import eduCanyons from '../../images/partnes/Local State and Educational/Local State and Education/Local/WhatsApp Image 2026-07-07 at 8.51.13 PM.jpeg'
import eduParkway from '../../images/partnes/Local State and Educational/Local State and Education/Local/WhatsApp Image 2026-07-07 at 8.51.23 PM.jpeg'

// Gold "Federally Authorized" spotlight for the Cisco card (NASA SEWP tab)
const FED_CARD_STYLE = { position: 'relative', border: '2px solid #16a34a', boxShadow: '0 0 0 4px rgba(22,163,74,0.12)' };
const FED_RIBBON_STYLE = { position: 'absolute', top: '-11px', left: '50%', transform: 'translateX(-50%)', display: 'inline-flex', alignItems: 'center', gap: '4px', background: '#16a34a', color: '#fff', fontSize: '10px', fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', padding: '3px 10px', borderRadius: '999px', whiteSpace: 'nowrap', boxShadow: '0 2px 6px rgba(22,163,74,0.35)', zIndex: 2 };

const ModernViewPartners = () => {
    const [activeTab, setActiveTab] = useState('sewp');

    const stats = [
        { number: '50+', label: 'Active Partners', icon: Users },
        { number: '25', label: 'Countries', icon: Globe },
        { number: '98%', label: 'Satisfaction Rate', icon: Star },
        { number: '15+', label: 'Years Experience', icon: Award }
    ];

    const sewpPartners = [
        { img: ciscoLogo, name: 'Cisco' },
        { img: dellLogo, name: 'Dell' },
        { img: hpLogo, name: 'HP' },
        { img: samsungLogo, name: 'Samsung' }
    ];

    const partners = [
        // NASA SEWP VI OEM partners (also shown under the NASA SEWP VI tab)
        { img: ciscoLogo, name: 'Cisco' },
        { img: dellLogo, name: 'Dell' },
        { img: hpLogo, name: 'HP' },
        { img: samsungLogo, name: 'Samsung' },
        { img: img1, name: 'US Fleet Tracking' },
        { img: img2, name: 'Ambir' },
        { img: img3, name: 'DT Research' },
        { img: img4, name: 'Duplim' },
        { img: img5, name: 'Amer Networks' },
        { img: img6, name: 'ATTO Technology, INC' },
        { img: img7, name: 'Advantech' },
        { img: img8, name: 'Adonit' },
        { img: img9, name: 'ACTi' },
        { img: img10, name: 'EZD' },
        { img: img11, name: 'Energizer' },
        { img: img12, name: 'Havis' },
        { img: img13, name: 'Legrand' },
        { img: img14, name: 'Lexmark' },
        { img: img15, name: 'Planar Systems' },
        { img: img16, name: 'Rocstar' },
        { img: img17, name: 'Supermicro' },
        { img: img18, name: 'Targus' },
        { img: img19, name: 'TouchDynamic' },
        { img: img20, name: 'UAG' },
        { img: img21, name: 'ViewSonic' },
        { img: img22, name: 'Wilson Electronics' },
        { img: img23, name: 'Accortec' },
        { img: img24, name: 'Add-On' },
        { img: img25, name: 'Altronix' },
        { img: img26, name: 'APC' },
        { img: img27, name: 'Apricorn' },
        { img: img28, name: 'American Battery' },
        { img: img29, name: 'Cherry' },
        { img: img30, name: 'Digi International' },
        { img: img31, name: 'Fellowes' },
        { img: img32, name: 'Geo Vision' },
        { img: img33, name: '10 Zig' },
        { img: img34, name: 'SIIG' },
        { img: img35, name: 'Rhombus' },
        { img: img36, name: 'Trend Net' },
        { img: img37, name: 'Visioneer' },
        { img: img38, name: 'Cyber Power' },
        { img: img39, name: 'The Joy Factory' },
        { img: img40, name: 'S.P. Richards' },
        { img: img41, name: 'Lenovo' },
        { img: img42, name: 'Gold Touch' },
        { img: img43, name: 'Perle' },
        { img: img44, name: 'Omnitron' },
        { img: img45, name: 'Peerless-AV' },
        { img: img46, name: 'PNY Technologies' },
        { img: img47, name: 'SEH' },
        { img: img48, name: 'Seiko' },
        { img: img49, name: 'Silicon Power' },
        { img: img50, name: 'Starkey' },
        { img: img51, name: 'Transition Networks' },
        { img: img52, name: 'Iogear' },
        { img: img53, name: 'V7' },
        { img: img54, name: 'Joyplex' },
        { img: img55, name: 'UNY Touch Manufacture' }
    ];

    const federal = [
        // Requested priority sequence — Department of Defense always first
        { img: fd2, name: 'Department of Defense' },
        { img: sealHomeland, name: 'Department of Homeland Security' },
        { img: sealDLA, name: 'Defense Logistics Agency' },
        { img: sealArmy, name: 'Department of the Army' },
        { img: sealAirForce, name: 'Department of the Air Force' },
        { img: sealNavy, name: 'Department of the Navy' },
        { img: sealCoastGuard, name: 'United States Coast Guard' },
        { img: sealVA, name: 'Department of Veterans Affairs' },
        { img: sealJustice, name: 'Department of Justice' },
        { img: sealGSA, name: 'General Services Administration' },
        // Additional federal clients
        { img: fd1, name: 'Department of Treasury' },
        { img: fd4, name: 'Department of Labor' },
        { img: fd5, name: 'Department of State' },
        { img: fd6, name: 'Department of Transportation' },
        { img: eduDeptEducation, name: 'Department of Education' },
        { img: fd9, name: 'Department of Interior' },
        { img: fd10, name: 'Transportation Command' },
        { img: fd11, name: 'Department of Agriculture' },
        { img: fd12, name: 'Department of Commerce' },
        { img: fd13, name: 'Department of Energy' },
        { img: fd14, name: 'Department of Housing' },
        { img: fd15, name: 'Department of HHS' }
    ];

    const local = [
        { img: local1, name: 'City of Anaheim' },
        { img: local2, name: 'City of Bakersfield' },
        { img: local3, name: 'City of Burbank' },
        { img: local4, name: 'City of Clovis' },
        { img: local5, name: 'City of Glendale' },
        { img: local6, name: 'City of Norco' },
        { img: local7, name: 'City of San Bernardino' },
        { img: local8, name: 'County of El Dorado' },
        { img: local9, name: 'Foothill Transit' },
        { img: local11, name: 'Kenton County Airport' },
        { img: local12, name: 'SAWS' },
        { img: local13, name: 'SEPTA' },
        { img: local14, name: 'Metropolitan Water District' },
        { img: local15, name: 'City of Irving' },
        { img: local16, name: 'Clark County NV' },
        { img: local17, name: 'Davenport' },
        { img: local18, name: 'El Paso' },
        { img: local19, name: 'Fayetteville' },
        { img: local21, name: 'Lexington KY' },
        { img: local22, name: 'Omnitrans' },
        { img: local23, name: 'Orange County Fire' },
        { img: local24, name: 'PSTA' },
        { img: local25, name: 'Riverbay' },
        { img: local26, name: 'Tarrant County TX' }
    ];

    const state = [
        { img: s1, name: 'NGEM' },
        { img: s2, name: 'CAMMNET' },
        { img: s3, name: 'COMMBUYS' },
        { img: s4, name: 'EMMA' },
        { img: s5, name: 'LCPSCM' },
        { img: s6, name: 'MD Courts' },
        { img: s7, name: 'NECO' },
        { img: s8, name: 'Ohio Buys' }
    ];

    // State, Local & Education merged into one client group
    const localStateEdu = [
        ...local,
        ...state,
        { img: local20, name: 'Granbury ISD' },
        { img: eduCanyons, name: 'Canyons School District' },
        { img: eduParkway, name: 'Parkway Schools' }
    ];

    const tabs = [
        { id: 'sewp', label: 'NASA SEWP VI', count: sewpPartners.length },
        { id: 'partners', label: 'Technology Partners', count: partners.length },
        { id: 'federal', label: 'Federal Clients', count: federal.length },
        { id: 'localstateedu', label: 'State, Local & Education', count: localStateEdu.length }
    ];

    const getActiveData = () => {
        switch (activeTab) {
            case 'sewp': return sewpPartners;
            case 'partners': return partners;
            case 'federal': return federal;
            case 'localstateedu': return localStateEdu;
            default: return sewpPartners;
        }
    };

    const getActiveTitle = () => {
        switch (activeTab) {
            case 'sewp': return 'NASA SEWP VI Partners';
            case 'partners': return 'Technology Partners';
            case 'federal': return 'Federal Clients';
            case 'localstateedu': return 'State, Local & Education Clients';
            default: return 'NASA SEWP VI Partners';
        }
    };

    return (
        <PageLayout>
            <PageHeader
                title="Our Partners"
                subtitle="Explore our comprehensive network of technology partners and valued clients"
                breadcrumbs={[
                    { label: 'Our Partners' }
                ]}
            />

            {/* Stats Section */}
            <section className="jk-vp-stats">
                <div className="jk-vp-stats__container">
                    <div className="jk-vp-stats__grid">
                        {stats.map((stat, index) => (
                            <div key={index} className="jk-vp-stats__item">
                                <div className="jk-vp-stats__icon">
                                    <stat.icon size={28} />
                                </div>
                                <span className="jk-vp-stats__number">{stat.number}</span>
                                <span className="jk-vp-stats__label">{stat.label}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Partners Content */}
            <section className="jk-vp-content">
                <div className="jk-vp-content__container">
                    {/* Tabs */}
                    <div className="jk-vp-tabs">
                        {tabs.map((tab) => (
                            <button
                                key={tab.id}
                                className={`jk-vp-tabs__btn ${activeTab === tab.id ? 'is-active' : ''}`}
                                onClick={() => setActiveTab(tab.id)}
                            >
                                {tab.label}
                                <span className="jk-vp-tabs__count">{tab.count}</span>
                            </button>
                        ))}
                    </div>

                    {/* Section Header */}
                    <div className="jk-vp-section-header">
                        <span className="jk-section-label">
                            <Users size={16} />
                            Our Network
                        </span>
                        <h2 className="jk-vp-section-header__title">
                            Meet Our <span className="highlight">{getActiveTitle()}</span>
                        </h2>
                        <p className="jk-vp-section-header__subtitle">
                            We collaborate with industry leaders to bring you the best solutions and services.
                        </p>
                        {activeTab === 'sewp' && (
                            <div className="jk-vp-section-header__sewp">
                                <span className="jk-vp-fed-badge">
                                    <ShieldCheck size={14} /> Federally Authorized
                                </span>
                                <Link to="/nasa-sewp-vi" className="jk-vp-section-header__link">
                                    View NASA SEWP VI Details
                                    <ArrowRight size={18} />
                                </Link>
                            </div>
                        )}
                    </div>

                    {/* Partners Grid */}
                    <div className="jk-vp-grid">
                        {getActiveData().map((partner, index) => {
                            const featured = partner.name === 'Cisco';
                            return (
                                <div key={index} className="jk-vp-card" style={featured ? FED_CARD_STYLE : undefined}>
                                    {featured && (
                                        <span style={FED_RIBBON_STYLE}><ShieldCheck size={11} /> Federally Authorized</span>
                                    )}
                                    <div className="jk-vp-card__logo">
                                        <img src={partner.img} alt={partner.name} />
                                    </div>
                                    <div className="jk-vp-card__name">{partner.name}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* CTA */}
            <ModernCTA />
        </PageLayout>
    );
};

export default ModernViewPartners;
